import { SubscribedModelPortfoliosState } from './subscribed-model-portfolios.interfaces';

export const subscribedModelPortfoliosInitialState: SubscribedModelPortfoliosState = {
	subscribedPortfolioMapping: new Map<string, string>()
};
